// src/constants/roStatus.js

export const TRANSPORT_TYPES = Object.freeze({
  WAITER: "WAITER",
  LOANER: "LOANER",
  SHUTTLE: "SHUTTLE",
  OTHER: "OTHER",
});

export const WORK_MIX = Object.freeze({
  MAINTENANCE: "MAINTENANCE",
  DIAGNOSIS: "DIAGNOSIS",
  OTHER: "OTHER",
});

export const PARTS_STATUS = Object.freeze({
  NONE: "NONE",
  PULLED: "PULLED",
  ORDERED: "ORDERED",
  ARRIVED: "ARRIVED",
  QUOTED: "QUOTED",
});

export const PARTS_ACTION_STATUS = Object.freeze({
  REVIEW: "REVIEW",
  PRE_PULLED: "PRE_PULLED",
  NO_ACTION: "NO_ACTION",
});

export const RO_STATUS = Object.freeze({
  AVAILABLE: "AVAILABLE",
  OPEN: "OPEN",
  DISPATCH: "DISPATCH",
  ASSIGNED: "ASSIGNED",
  IN_PROGRESS: "IN_PROGRESS",
  WAITING_ON_PARTS: "WAITING_ON_PARTS",
  COMPLETED: "COMPLETED",
  ARCHIVED: "ARCHIVED",
});

export const RO_LIFECYCLE = Object.freeze({
  OPEN: "OPEN",
  WAITING_FOR_PARTS: "WAITING_FOR_PARTS",
  WAITING_FOR_ASSIGNMENT: "WAITING_FOR_ASSIGNMENT",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
});

export const PARTS_REQUEST_TYPE = Object.freeze({
  NEED_PARTS: "NEED_PARTS",
  NEED_PRICE: "NEED_PRICE",
});

export const EMPLOYMENT_STATUS = Object.freeze({
  ACTIVE: "ACTIVE",
  SUSPENDED: "SUSPENDED",
  TERMINATED: "TERMINATED",
});

export const ATTENTION_FLAGS = Object.freeze({
  ADVISOR: "ATTN: Advisor",
  PARTS: "ATTN: Parts",
  DISPATCH: "ATTN: Dispatch",
  FOREMAN: "ATTN: Foreman",
  SERVICE_MANAGER: "ATTN: Service Manager",
});

export const TRANSPORT_LABELS = Object.freeze({
  [TRANSPORT_TYPES.WAITER]: "Waiter",
  [TRANSPORT_TYPES.LOANER]: "Loaner",
  [TRANSPORT_TYPES.SHUTTLE]: "Shuttle",
  [TRANSPORT_TYPES.OTHER]: "Other",
});

export const WORK_MIX_LABELS = Object.freeze({
  [WORK_MIX.MAINTENANCE]: "Maintenance",
  [WORK_MIX.DIAGNOSIS]: "Diagnosis",
  [WORK_MIX.OTHER]: "Other",
});

export const PARTS_STATUS_LABELS = Object.freeze({
  [PARTS_STATUS.NONE]: "None",
  [PARTS_STATUS.PULLED]: "Parts Available",
  [PARTS_STATUS.ORDERED]: "Parts Ordered",
  [PARTS_STATUS.ARRIVED]: "Parts Arrived",
  [PARTS_STATUS.QUOTED]: "Quoted",
});

export const PARTS_ACTION_STATUS_LABELS = Object.freeze({
  [PARTS_ACTION_STATUS.REVIEW]: "Review",
  [PARTS_ACTION_STATUS.PRE_PULLED]: "Pre-Pulled",
  [PARTS_ACTION_STATUS.NO_ACTION]: "No Action",
});

export const RO_STATUS_LABELS = Object.freeze({
  [RO_STATUS.AVAILABLE]: "Available",
  [RO_STATUS.OPEN]: "Open",
  [RO_STATUS.DISPATCH]: "Unassigned",
  [RO_STATUS.ASSIGNED]: "Assigned",
  [RO_STATUS.IN_PROGRESS]: "In Progress",
  [RO_STATUS.WAITING_ON_PARTS]: "Waiting Parts",
  [RO_STATUS.COMPLETED]: "Completed",
  [RO_STATUS.ARCHIVED]: "Archived",
});

export const RO_LIFECYCLE_LABELS = Object.freeze({
  [RO_LIFECYCLE.OPEN]: "Open",
  [RO_LIFECYCLE.WAITING_FOR_PARTS]: "Waiting for Parts",
  [RO_LIFECYCLE.WAITING_FOR_ASSIGNMENT]: "Waiting for Assignment",
  [RO_LIFECYCLE.IN_PROGRESS]: "In Progress",
  [RO_LIFECYCLE.COMPLETED]: "Completed",
});